import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import * as url from "../../../../helpers/url_helper";
import { convertLocalDate } from "../../../../Utils/configController";
import {
  Alert,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import LogsDataTable from "./LogsDataTable";

export interface UserActionProps {
  userId: any;
  selectedPremise?: any;
}

const UserAction = ({ userId }: UserActionProps) => {
  const [isOpneRequestModel, setOpenRequestModel] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<any>({});
  const [isOpenResponseModel, setOpenResponseModel] = useState<boolean>(false);
  const [responseData, setResponseData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const columns = [
    {
      name: "Created",
      selector: (row: any) => row?.createdAt || "",
      cell: (row: any) => (
        <div>{row?.createdAt ? convertLocalDate(row.createdAt) : "-"}</div>
      ),
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Method",
      selector: (row: any) => row?.method || "",
      cell: (row: any) => <div>{row?.method || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "IP Address",
      selector: (row: any) => row?.ipAddress || "",
      cell: (row: any) => <div>{row?.ipAddress || "-"}</div>,
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Request",
      cell: (row: any) => (
        <button
          style={{ border: "none", outline: "none", background: "none" }}
          onClick={() => handleViewRequest(row)}
        >
          <span
            className="badge bg-primary"
            style={{
              height: "25px",
              width: "60px",
              fontSize: "12px",
              padding: "6px",
            }}
          >
            View
          </span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0.8,
    },
    {
      name: "Response",
      cell: (row: any) => (
        <button
          style={{ border: "none", outline: "none", background: "none" }}
          onClick={() => handleViewResponse(row)}
        >
          <span
            className="badge bg-primary"
            style={{
              height: "25px",
              width: "60px",
              fontSize: "12px",
              padding: "6px",
            }}
          >
            View
          </span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0.8,
    },
    {
      name: "OS Name",
      selector: (row: any) => row?.createdUserDeviceId?.osName || "",
      cell: (row: any) => <div>{row?.createdUserDeviceId?.osName || "-"}</div>,
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "OS Version",
      selector: (row: any) => row?.createdUserDeviceId?.osVersion || "",
      cell: (row: any) => (
        <div>{row?.createdUserDeviceId?.osVersion || "-"}</div>
      ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Device Info",
      selector: (row: any) => row?.createdUserDeviceId?.deviceInfo || "",
      cell: (row: any) => (
        <div>{row?.createdUserDeviceId?.deviceInfo || "-"}</div>
      ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
  ];

  const handleViewRequest = (rowData: any) => {
    setOpenRequestModel(true);
    setRequestData(rowData.request);
  };

  const handleViewResponse = (rowData: any) => {
    setOpenResponseModel(true);
    setResponseData(rowData.response);
  };

  const toggleRequestModel = () => {
    setOpenRequestModel(!isOpneRequestModel);
  };

  const toggleResponsetModel = () => {
    setOpenResponseModel(!isOpenResponseModel);
  };

  return (
    <div>
      <ToastContainer />
      {/* VIEW REQUEST MODEL */}
      <Modal
        isOpen={isOpneRequestModel}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleRequestModel}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            {"Request"}
          </ModalHeader>
          <ModalBody>
            {/* {requestData} */}
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(requestData, null, 2)}
            </pre>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-dark"
              type="submit"
              onClick={() => setOpenRequestModel(false)}
            >
              Ok
            </button>
          </ModalFooter>
        </div>
      </Modal>

      {/* VIEW RESPONSE MODEL */}
      <Modal
        isOpen={isOpenResponseModel}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleResponsetModel}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            {"Response"}
          </ModalHeader>
          <ModalBody>
            {/* {responseData} */}
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(responseData, null, 2)}
            </pre>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-dark"
              type="submit"
              onClick={() => setOpenResponseModel(false)}
            >
              Ok
            </button>
          </ModalFooter>
        </div>
      </Modal>
      <LogsDataTable
        apiURL={`${url.BASE_URL}${url.GET_USER_ACTION_LIST}`}
        title="Logs"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
      />
    </div>
  );
};

export default UserAction;
